import { useQuery } from '@tanstack/react-query'
import { BankQueryKeys } from '@/modules/bank/keys'
import { getPaymentGatewayAnalytics } from '../../services'
import type { GetPaymentGatewayAnalyticsParams } from '@/modules/bank/type'

export default function useQueryGetPaymentGatewayAnalytics(
	params?: GetPaymentGatewayAnalyticsParams,
) {
	return useQuery({
		queryKey: [BankQueryKeys.PaymentGatewayAnalytics, params],
		queryFn: () => getPaymentGatewayAnalytics(params),
		staleTime: 5 * 60 * 1000,
	})
}
